<template>
    <div class="card-base ut-flex ut-w-full ut-m-0 ut-mb-4">
      <div class="list-icon">
        <svg-loader
        :name="listIcon"
        :width="16"
        :color-class="''" />
      </div>
      <div class="ut-w-full">
        <div class="ut-w-full ut-text-sm text-content" v-html="textContent">{{textContent}}</div>
        <div class="ut-w-full ut-text-sm text-content" v-if="noteContent" v-tooltip="{content: noteContent, classes: ['info'], trigger: 'hover click'}">"{{noteContent | truncateString(260)}}"</div>
        <div class="ut-w-full text-date">{{activityDate}}</div>
        <div class="ut-w-full ut-flex extra-info">
          <span class="ut-flex ut-ml-0 ut-mr-4" v-if="showExtraInfo">
            <svg-loader
            name="icon-pin"
            :width="18" />
            <span class="ut-ml-2">{{extraInfo}}</span>
          </span>
          <span class="ut-flex ut-ml-0 ut-mr-4">
            <svg-loader
            name="icon-user-homeowner"
            :width="20" />
            <span class="ut-ml-2">Selling profile updated</span>
          </span>
        </div>
      </div>
      <div>
        <!-- <i class="right-arrow-shape"></i> -->
      </div>
    </div>
</template>

<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';

export default {
  name: 'ProspectingActivityCardDetails',
  components: {
    SvgLoader,
  },
  props: {
    listIcon: {
      type: String,
      required: false,
    },
    styledClass: {
      type: String,
      required: false,
    },
    textContent: {
      type: String,
      required: false,
    },
    noteContent: {
      type: String,
      required: false,
    },
    activityDate: {
      type: String,
      required: false,
    },
    showExtraInfo: {
      type: Boolean,
      required: false,
    },
    extraInfo: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
    };
  },
  computed: {
  },
  created() {},
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.list-icon {
  height: 29px;
  width: 29px;
  background-color: rgba(78,189,208,0.26);
  @apply ut-flex ut-rounded-full ut-text-teal-200 ut-mt-3 ut-mr-6 ut-flex-shrink-0;
}
.card-base {
  min-height: 150px;
  height: auto;
  border-radius: 3px;
  background-color: #FFFFFF;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.08), 0 1px 4px 1px rgba(0,0,0,0.04);
  @apply ut-px-8 ut-py-4;
}
.right-arrow-shape {
  box-sizing: border-box;
  height: 5px;
  width: 5px;
  border-top: 1px solid #25BA68;
  border-right: 1px solid #25BA68;
  transform: rotate(45deg);
  float: right;
}
.text-content {
  color: #002623;
  line-height: 20px;
}
.text-date {
  color:#8C8B89;
  font-size: 12px;
  line-height: 20px;
}
.extra-info {
  color: #33837C;
  font-size: 12px;
  line-height: 22px;
  flex-wrap: wrap;
  @apply ut-py-2;
}
</style>
